import React from "react";
const res = {
  "monthNamesS": ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  "monthNames": ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  "monthNamesL": ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  "dayNames": ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
  "dayNamesL": ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday ', 'Sunday'],
  "yearsS": "Y",
  "monthS": "M",
  "daysS": "D",
  "hoursS": "h",
  "minutesS": "min",
  "oClock": "o' clock",
  "unknown": "unknown time",
  "bc": "BC",
  "bn": "bn.",
  "mn": "mn.",
  "thousands": "k",
  "th": "s",
  "cen": ". cen.",
  "mil": ". mil.",
  "bil": ". bil.",
  "tril": ". tril.",
  "mnCen": ". mnCen.",
  "bnCen": ". bnCen.",
  "trilCen": ". trilCn.",
  "bilCen": ". bilCen.",
  "born": "born",
  "earliest": "earliest",
  "start": "Start",
  "founded": "Foundation",
  "discovered": "Discovery",
  "published": "Publication",
  "firstDescribed": "First description",
  "baptized": "baptized",
  "premiered": "World premiere",
  "firstMentioned": "First mention",
  "activeYears": "Years of activity",
  "opened": "opens",
  "inaugurated": "Oath of Office",
  "activeSince": "active since",
  "production": "Production",
  "moment": "Time",
  "maidenFlight": "Maiden flight",
  "died": "died",
  "latest": "at the latest",
  "end": "end",
  "closed1": "Decommissioning",
  "dissolved": "Dissolved",
  "missingSince": "missing since",
  "activeUntil": "active until",
  "discontinued": "set",
  "closed": "closed",
  "landing": "Landing",
  "reentry": "Re-entry"
};
export default res;